<template>
  <div id="contenedor-eliminar-poragramainversion">
    <v-card>
      <v-card-title class="secondary--text">
        Eliminar Programa de Inversión
      </v-card-title>
      <v-card-text>
        ¿Desea eliminar el programa de inversión "{{programaInversionEliminar.nombre}}"?
      </v-card-text>
      <v-divider class="bkground" />
      <v-card-actions>
        <v-spacer></v-spacer>
        <custom-button
          @click="cerrar"
          tipo="formCancelar"
          label="Cancelar"
          class="mr-3">
        </custom-button>
        <custom-button
          @click="mixEliminarProgramaInversion"
          :disabled="enviandoFormulario"
          :loading="enviandoFormulario"
          tipo="formAceptar"
          label="Eliminar">
        </custom-button>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import mixCatalogoProgramasInversion from './mixCatalogoProgramasInversion';
import CustomButton from '@/components/buttons/Button.vue';

export default {
  name: 'CatalogosProgramasInversionEliminar',
  mixins: [mixCatalogoProgramasInversion],
  props: {
    programaInversionEliminar: {
      type: Object,
      required: true,
    },
  },
  components: {
    CustomButton,
  },
  data() {
    return {
      esFormularioValido: false,
      enviandoFormulario: false,
      itemsnormatividad: [
        { origen: 'Federal', valor: 1 },
        { origen: 'Estatal', valor: 2 },
      ],
      itemsejercicio: [2021, 2022, 2023],
      programaInversion: {
        ejercicio: this.programaInversionEliminar.ejercicio,
        clave: this.programaInversionEliminar.clave,
        nombre: this.programaInversionEliminar.nombre,
        normatividad: this.programaInversionEliminar.normatividad,
      },
    };
  },
  methods: {
    cerrar() {
      this.$emit('cerrar');
    },
  },
};
</script>

<style>
</style>
